import { render } from "./Photo.vue?vue&type=template&id=833accde&scoped=true"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"

import "./Photo.vue?vue&type=style&index=0&id=833accde&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833accde"]])

export default __exports__